//cn.js

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  message: {
    'veS_overall_s_pl': '请输入关键字',
  },
  ...zhLocale
}

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js